export default __webpack_public_path__ + "static/1_12-88d3baa526fafe6a770b81dcb52fbaea.png";